import React, {Component} from 'react';
import ListGroupCollapse from "../../common/ListGroupCollapse";
import PrescriptionHistory from "../Prescription/PrescriptionHistory";
import {Container} from "reactstrap";
import _ from "lodash";
import Allergies from "./Allergies";
import Warnings from "./Warnings";

class RXWarnings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: {},
            collapse: false
        };
        this.toggle = this.toggle.bind(this);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        let headers = {};
        const draft = this.props.draft;
        const prescriptionHistory = this.props.prescriptionHistory;
        headers.medicationHistory = {
            header: 'Medication History',
            content: <div>
                {!_.isEmpty(prescriptionHistory.medicationHistory) ?
                    <PrescriptionHistory prescriptionHistory={prescriptionHistory} prescriberInfo={draft.prescriberInfo}/>
                    : <span>No medication history available</span>}
            </div>
        };
        headers.allergies = {
            header: 'Allergies',
            content:
                <div>
                    {!_.isEmpty(prescriptionHistory.allergies) ?
                        <Allergies prescriptionHistory={prescriptionHistory}/>
                        : <span>No allergies available</span>}
                </div>
        };
        headers.warnings = {
            header: 'Warnings',
            content:
                <div>
                    {!_.isEmpty(prescriptionHistory.warnings) ?
                        <Warnings prescriptionHistory={prescriptionHistory}/>
                        : <span>No warnings available</span>}
                </div>
        };
        headers.prescriber = {
            header: 'Prescriber',
            content: <div>
                <p><strong>Prescriber:</strong> {draft.prescriberInfo.name}</p>
                <p><strong>Contact info:</strong> {draft.prescriberInfo.phoneNumber}</p>
            </div>
        };

        this.setState({
            headers: headers
        })
    };

    toggle(headers) {
        this.setState({collapse: this.state.collapse === headers ? null : headers});
    }

    render() {
        const {headers} = this.state;
        return (
            <Container>
                {Object.keys(headers).map((key, index) =>
                    <ListGroupCollapse key={index}
                                       content={headers[key]}
                                       isOpen={this.state.collapse === headers[key]}
                                       toggle={this.toggle}
                                       icon="fas fa-plus-square mr-2"
                    />
                )}
            </Container>
        );
    }
}

export default RXWarnings;
